import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { SectionCTA } from './SectionCTA';
export function Bonuses() {
  return <section className="bg-ink px-3 py-16 text-white sm:px-4" aria-labelledby="bonus-title" data-id="element-47" data-mp="plsnad7r1gdg">
      <div className="mx-auto max-w-4xl" data-id="element-48" data-mp="at8v27m50tas">
        <div className="text-center" data-id="element-49" data-mp="ftefp3tzpfjd">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-50" data-mp="fsbt383p9z99">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="5wi7kz806vfc" />5 exclusive bonuses
          </span>
          <h2 id="bonus-title" className="mt-5 px-1 font-serif text-[2rem] font-bold leading-tight sm:text-5xl" data-id="element-52" data-mp="3o2502g6e2o16">
            Get these 5 bonuses <span className="italic text-gold" data-id="element-53" data-mp="3t182dsuzig5g">free</span> with your order today
          </h2>
          <p className="mt-3 text-lg text-white/70" data-id="element-54" data-mp="1mbjn8ryt7vqn">
            Total bonus value: <span className="font-bold text-gold-light line-through decoration-2" data-id="element-55" data-mp="1r9l7vhbvw348">$147</span>
          </p>
        </div>

        <div className="mt-10 space-y-6" data-id="element-56" data-mp="3id54x7cwv5bb">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-3xl bg-white text-ink" data-id="element-57" data-mp="3dg4ygvc5g0jo">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-58" data-mp="3r79ttl8hi6o7" />
              <div className="px-5 pb-7 pt-2 sm:px-10 sm:pb-10" data-id="element-59" data-mp="3n67oqnrvz0eb">
                <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-60" data-mp="2zfanq61mpnhu">
                  <p className="font-serif text-lg font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-61" data-mp="2zhezfa5rrqso">
                    Bonus #{b.number}
                  </p>
                  <p className="text-sm font-bold" data-id="element-62" data-mp="38htpemtohu2i">
                    <span className="text-muted line-through" data-id="element-63" data-mp="33hfduusvc1zq">Value: ${b.value}</span>
                    <span className="ml-2 rounded-md bg-ink px-2.5 py-1 text-gold" data-id="element-64" data-mp="nq19muqaauqb">FREE TODAY</span>
                  </p>
                </div>
                <h3 className="mt-2 font-serif text-[1.6rem] font-bold leading-tight sm:text-3xl" data-id="element-65" data-mp="ipwvhbcumc39">{b.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-66" data-mp="3ciemd4oadwzm">{b.text}</p>
              </div>
            </article>)}
        </div>

        <SectionCTA label="I want all 5 bonuses" tone="dark" data-id="element-67" data-mp="3ljum8ihh6gpl" />
      </div>
    </section>;
}